import angular from 'angular'

import envRaw from '../../utils/env-raw'
import setCss from '../../utils/set-css'
import StrictObj from '../../utils/strict-obj'
import getScrollbarSize from '../../utils/get-scrollbar-size'

import { onClick, offClick } from '../../utils/on-click'

import Template from './gallery-text-preview.component.ejs'

angular
  .module('ggs.gallery-text-preview')
  .component('ggsGalleryTextPreview', {
    template: Template(StrictObj({
      LE: envRaw.liveEditMode
    })),
    controller: GalleryTextPreviewComponent,
    bindings: {
      ggsPost: '<',
      ggsProperties: '<',
      ggsContentFailCallback: '<',
      ggsContentDoneCallback: '<'
    }
  })

const QS_CONTENT = '.ggs-gallery-text-preview'

const BASE_WIDTH_STEP = 15

function GalleryTextPreviewComponent(
  $q,
  qh,
  domh,
  $log,
  $scope,
  $element,
  fontEmitter,
  AdvancedHeightCache) {

  const $ctrl = $scope.$ctrl = StrictObj(this)
  const sign = `galleryTextPreview[id=${$ctrl.ggsPost.id}]`

  let clickableX = 0
  const contentElm = domh.find($element, QS_CONTENT)
  const heightCache = AdvancedHeightCache('galleryTextPreview', contentElm, toBaseWidth)

  $ctrl.$postLink = () => {
    onClick(contentElm, clickHandler)
    fontEmitter.pre(heightCache.clear)
    return $q.resolve()
      .then(heightCache.fill)
      .then(callDoneCallback)
      .catch(qh.catchCanceled(catchCanceledError))
      .catch(catchError)
  }

  $ctrl.$onDestroy = () => {
    heightCache.destroy()
    fontEmitter.off(heightCache.clear)
    offClick(contentElm, clickHandler)
  }

  // init

  function callDoneCallback() {
    return $ctrl.ggsContentDoneCallback(
      calcContentWidth,
      calcContentHeight,
      applyShowcaseSize)
  }

  function catchCanceledError(err) {
    $log.debug(`${sign}#catchCanceledError: heightCache initialization has been canceled:`, err)
  }

  function catchError(err) {
    $log.error(`${sign}#catchError: problem appeared during initialization:`, err)
  }

  // external

  function calcContentWidth(showcaseHeight) {
    if (showcaseHeight > 500) {
      return showcaseHeight * 1.06
    } else if (showcaseHeight < 100) {
      return showcaseHeight * 2.3
    } else {
      // https://www.wolframalpha.com/input/?i=log+fit+{100,230},{200,360},{300,430},{400,480},{500,530}
      // https://www.wolframalpha.com/input/?i=y=183ln(0.035x)
      return 183 * Math.log(0.035 * showcaseHeight)
    }
  }

  function calcContentHeight(showcaseWidth) {
    return heightCache.calc(showcaseWidth)
  }

  function applyShowcaseSize(psmSize) {
    const cntWidth = toBaseWidth(psmSize.showcaseWidth)
    const cntHeight = calcContentHeight(cntWidth)

    const width = cntWidth
    const height = cntHeight > psmSize.showcaseHeight ? psmSize.showcaseHeight : null
    const overflowY = cntHeight > psmSize.showcaseHeight ? 'auto' : null
    const marginTop = cntHeight < psmSize.showcaseHeight ? Math.round((psmSize.showcaseHeight - cntHeight) / 2) : null
    const marginLeft = Math.round((psmSize.showcaseWidth - width) / 2)
    clickableX = cntHeight > psmSize.showcaseHeight ? width - getScrollbarSize() : width
    setCss(contentElm, { width, height, marginTop, overflowY, marginLeft })
  }

  // helpers

  function toBaseWidth(width) {
    return Math.round(Math.floor(width / BASE_WIDTH_STEP) * BASE_WIDTH_STEP)
  }

  function clickHandler(event) {
    if (event.target.nodeName === 'A') {
      event.stopPropagation()
    }

    if (event.target === contentElm && event.offsetX > clickableX) {
      event.stopPropagation()
    }
  }
}
